<template>
  <div class="moduletabs" :class="{ 'moduletabs-singleline': singleLine }">
    <module-tabbar-all-tab
      v-if='modules.length > 1'
      :isActive="activeTab === 'all'"
      @select="onTabSelect('all')"
    ></module-tabbar-all-tab>
    <module-tabbar-tab
      v-for="module of modules"
      :key="module.connection"
      :connectionId="module.connection"
      :isActive="activeTab === module.connection"
      @select="onTabSelect(module.connection)"
    >
      {{ module.name }}
    </module-tabbar-tab>
  </div>
</template>

<script>
import ModuleTabbarAllTab from './ModuleTabbarAllTab'
import ModuleTabbarTab from './ModuleTabbarTab'
import ScreenSizeMixin from '@/mixins/screensize'

export default {
  name: 'module-tabbar',
  props: {
    activeTab: Number,
    modules: Array,
    singleLine: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:activeTab'],
  mixins: [ScreenSizeMixin],
  methods: {
    onTabSelect (tabId) {
      this.$emit('update:activeTab', tabId)
    }
  },
  components: {
    'module-tabbar-all-tab': ModuleTabbarAllTab,
    'module-tabbar-tab': ModuleTabbarTab
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/css/_constants";
  @import "../../assets/css/components/moduleTab";
</style>
